import React from 'react'
import './dorm-list.less'
import { withRouter } from 'react-router'
import { setHeader } from '@/util/set-header'
import ReactDOM from 'react-dom'
import { NoticeBar, Tabs, Button } from 'antd-mobile'
import DormListList from './dorm-list-list/dorm-list-list'
import EmptyPage from '@/pages/sanyi/dorm-manage/empty-page/empty-page'
import Cookies from 'universal-cookie'
import md5 from 'md5'
import { getUrlQueryDic } from '@/util/util'
import { checkReserveApi } from '@/api/sany'
import { signToJson } from '@/util/des'
import { phonePlatform } from '@/util/util'
// import { phonePlatform } from '@/util/util';
const cookie = new Cookies()

@(withRouter as any)
export default class DormList extends React.Component<any, any> {
  // tabs = [{title: '员工宿舍'}, {title: '招待所'}]
  mainDiv!: any

  constructor(prop: any) {
    super(prop)
    window.scroll(0, 0)
    this.mainDiv = React.createRef()
    this.state = {
      empty: true,
      tabIndex: 0,
      height: (document.documentElement.clientHeight * 3) / 4,
    }
    this.leftClick = this.leftClick.bind(this)
    this.tabChange = this.tabChange.bind(this)
    // this.emptyBtnClick = this.emptyBtnClick.bind(this)
    const cookie = new Cookies()
    // cookie.set('sany_phone', '15868194226')//13348692480 张孟军：15868194226
    // cookie.set('sany_communityId', '12151165')
    // const sign = 'z4Md82k7P9sJHyPJATQmWYPukQ75HxKvilcfbGOPOTEwiC1Z4dCjD3TPV3Ux5V1S0OxWnV3z84p9PpSblChhINl4Uyu9DM2j8d0GhsJfBqND9dJiMdlJwjL2n9qZ%2FPvcmkjPuYUMomHIVzoPrr51Jy0Z7FPu8B1YsiUbLEYsYNupHFl2Ul4fOwdK8qtbl84r'//this.props.location.query.sign
    // const dic = signToJson(sign)
    // console.log('dic', dic)
    // communityId: 12151165
    // communityTel: ""
    // custId: "-1"
    // tel: "15001779075"
    // type: 5
    // userId: 202400493
    const str = this.props.location.search
    // const queryDic = getUrlQueryDic(this.props.location.search)
    const index2 = str.indexOf('sign')
    const queryDic2 = index2 !== -1 ? getUrlQueryDic(str.substring(index2)) : ''
    console.log(queryDic2, 'queryDic22')
    if (queryDic2.sign) {
      const sign = queryDic2.sign
      const dic = signToJson(sign)
      console.log('dic', dic)
      if (dic && dic.tel) {
        cookie.set('sany_phone', dic.tel)
        const key = md5(process.env.REACT_APP_MD5_KEY + dic.tel.trim())
        cookie.set('sany_phone_app_sign', key)
        // cookie.set('sany_phone', '15868194226')
      }
      if (dic && dic.communityId) {
        cookie.set('sany_communityId', dic.communityId)
        // cookie.set('sany_communityId', '12151157')
      }
    }
  }
  componentDidMount() {
    setHeader({ title: '住宿列表', leftClick: this.leftClick })
    if (!this.state.empty) {
      const height =
        document.documentElement.clientHeight -
        (
          ReactDOM.findDOMNode(this.mainDiv.current) as any
        ).getBoundingClientRect().top
      this.setState({ height })
    }
    function callback() {
      // if (window.AlipayJSBridge) {
      //   window.AlipayJSBridge.call('sy_easywork_setTitleBarVisibility', {'visible':'false'},() => {})
      // }
    }
    document.addEventListener('AlipayJSBridgeReady', callback, false)
    // const platform = phonePlatform()
    // if (platform === 'iOS') {
    // document.addEventListener('AlipayJSBridgeReady', callback, false);
    // } else if (platform === 'Android') {
    // window.addEventListener('AlipayJSBridgeReady', callback, false);
    // }
    sessionStorage.removeItem('reservationType')
    sessionStorage.removeItem('endTime')
    sessionStorage.removeItem('changeDepartTypeName')
    sessionStorage.removeItem('changeDepartTypeId')
    sessionStorage.removeItem('changePrimaryOrganizationName')
    sessionStorage.removeItem('changePayTypeDepartment')
    sessionStorage.removeItem('sanyStoreId')
    sessionStorage.removeItem('sanyStoreName')
    sessionStorage.removeItem('sanyCityName')
    sessionStorage.removeItem('sanyCityId')
    const cookie = new Cookies()
    const phone = cookie.get('sany_phone')
    this.checkReserveIsEmpty(phone)
  }

  leftClick() {
    try {
      if (window.AlipayJSBridge) {
        window.AlipayJSBridge.call(
          'sy_easywork_closeWebview',
          { visible: 'false' },
          () => {},
        )
      } else {
        //返回App
        window.location.href =
          'uhomeoc://thirdparty.goBack?params={type:native}'
      }
    } catch (e) {}
  }
  // rightBtn() {
  //   return (
  //     <div onClick={() => this.bookingRoom()} style={{color: '#e94f4f'}}>住宿申请</div>
  //   )
  // }

  bookingRoom(val: any) {
    this.props.history.push({
      pathname: '/sany/book-room',
      state: { type: 'reservation', propertyType: val },
    })
    sessionStorage.setItem('reservationType', 'reservation')
  }

  tabChange(tab: any, index: number) {
    this.setState({
      tabIndex: index,
    })
  }

  emptyComponent() {
    return (
      <div>
        {/* <EmptyPage title="您还没预订" brief="快去添加预订房源吧"  btnClick={this.emptyBtnClick}/> */}
        <EmptyPage title="您还没有预约" brief="点击下方按钮，添加预约房源吧" />
        {/* <div className="submit-but-empay" onClick={() => this.bookingRoom()}>
          申请宿舍
         </div> */}
        <div className="subBtn">
          {cookie.get('app_Type') === '3' ? (
            <div className="submit-buttom">
              <Button
                className="primaryColor"
                onClick={() => this.bookingRoom('3')}
              >
                申请员工宿舍
              </Button>
            </div>
          ) : cookie.get('app_Type') === '1' ? (
            <div className="submit-buttom">
              <Button
                className="dangerColor"
                onClick={() => this.bookingRoom('1')}
              >
                申请招待所
              </Button>
            </div>
          ) : (
            <div>
              <div className="submit-buttom1">
                <Button
                  className="primaryColor"
                  onClick={() => this.bookingRoom('3')}
                >
                  申请员工宿舍
                </Button>
              </div>
              <div className="submit-buttom2">
                <Button
                  className="dangerColor"
                  onClick={() => this.bookingRoom('1')}
                >
                  申请招待所
                </Button>
              </div>
            </div>
          )}
          {/* <div className="submit-buttom1">
            <Button  className='primaryColor' onClick={() => this.bookingRoom('3')}>
              申请员工宿舍
            </Button>
          </div>
          <div className="submit-buttom2">
            <Button  className='dangerColor' onClick={() => this.bookingRoom('1')}>
              申请招待所
            </Button>
          </div> */}
        </div>
      </div>
    )
  }

  // emptyBtnClick() {
  //   console.log(1)
  //   this.bookingRoom()
  // }

  async checkReserveIsEmpty(phone: string) {
    const { data } = await checkReserveApi({
      phone: phone,
      room_property: cookie.get('app_Type'),
    })
    // const { data } = await checkReserveApi({ phone: '18337719432'})
    if (data.code === 'SUCCESS') {
      if (typeof data.data === 'boolean') {
        this.setState({
          empty: !data.data,
        })
      }
    }
  }

  tabsComponent() {
    return (
      // <Tabs tabs={this.tabs} initialPage={this.state.tabIndex} swipeable={false} onChange={this.tabChange}>
      <div style={{ height: this.state.height }} ref={this.mainDiv}>
        <DormListList type={cookie.get('app_Type')} />
      </div>
      // <div style={{height: this.state.height}} ref={this.mainDiv}>
      //   <DormListList type="1"/>
      // </div>
      // </Tabs>
    )
  }

  render() {
    return (
      // <div className="dorm-list">
      <div
        className={phonePlatform() === 'iOS' ? 'dorm-list-hei' : 'dorm-list'}
      >
        {/* <NoticeBar mode="closable" marqueeProps={{ loop: true }}>温馨提示：住招待所的员工请合理安排退宿时间哦！下午2-4点退，会加收半天费用，4点之后退会加收一天费用。</NoticeBar> */}
        {cookie.get('app_Type') === '1' ? (
          <NoticeBar mode="closable" marqueeProps={{ loop: true }}>
            温馨提示：招待所员工退房时间为14:00点前，14:00点前未退房，加收半天房费，18:00点以后退房的，加收一天房费。
          </NoticeBar>
        ) : (
          ''
        )}
        {this.state.empty ? this.emptyComponent() : this.tabsComponent()}
      </div>
    )
  }
}
